const ProductTypes = {
    DEVELOPMENT: 'product_development',
    SELECTION: 'product_selection',
    SELECTION_DEVELOPMENT: 'product_selection_development',
    TALENT_FIT: 'product_talent_fit',
    TALENT_NAVIGATOR: 'product_talent_navigator',
    BUILDING_DOCKS: 'product_building_docks',
    TALENT_SCAN: 'product_talent_scan',
    TEAM_AND_ORGANISATION: 'product_team_and_organisation'
};

export default ProductTypes;
